
webpack.register(
    'blocks/leaderboard-drawer/recap/recap',
    function() {
        return import('blocks/leaderboard-drawer/recap/recap');
    },
    true
);